// Seed for the journey editor (create mode) when branching off a touchpoint: a paused
// sub-journey whose entry segment matches customers who responded to `triggerTp`.
// attribute_id must be numeric — the API ignores a string attribute id.
export function branchJourneySeed(triggerTp) {
  return {
    name: `${triggerTp.name} – branch`,
    state_enum: 'PAUSED',
    segment: {
      condition_operator: 'AND',
      condition: [{
        criteria_operator: 'AND',
        criteria_id_1: [{ type: 'attribute', attribute_id: Number(triggerTp.response_attribute_id), operator: 'HAS_VALUE', value: [] }],
      }],
    },
  };
}
